import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
import {profileFields} from "../../../../guest/login/login.graphql";
import {institutionRoleFields} from "../instution-role/instution-role.graphql";
import {instutionUsersgetField} from "../instution-user/instution-user.graphql";

export const designationFields =`
id
designationUniqueId
designationShortForm
designationName
`;



export const GET_INSTUTIONS_DESIGNATION = gql`
query getAllDesignations($institutionUniqueId: String){
    getAllDesignations(institutionUniqueId:$institutionUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${designationFields}
    }
  }
}
`
;

export const CREATE_INSTUTION_DESIGNATION = gql`
mutation createInstitutionDesignationMutation($input: InstitutionDesignationInputObjects!) {
  createInstitutionDesignationMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${designationFields}
    }
  }
}
`
;

export const ASSIGN_USERS_TO_INSTUTION_DESIGNATION = gql`
mutation AssignUserToDesignationMutation($input: UserDesignationInputObjects!) {
  assignUserToDesignationMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${instutionUsersgetField}
    }
  }
}
`;

export const ASSIGN_USER_TYPE = gql`
mutation AssignUserTypeToInstitutionUser($profileUniqueId: String, $userType: InstitutionUserTypeInum) {
  assignUserTypeToInstitutionUser(profileUniqueId: $profileUniqueId, userType: $userType) {
    ${baseResponseGraphqlField}
    data {
      ${instutionUsersgetField}
    }
  }
}
`;


export const UPDATE_INSTUTION_DESIGNATION = gql`
mutation updateInstitutionDesignationMutation($input: InstitutionDesignationInputObjects!) {
  updateInstitutionDesignationMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${designationFields}
    }
  }
}
`
;
export const DELETE_DESIGNATION = gql`
mutation deleteInstitutionDesignationMutation($designationUniqueId: String!) {
  deleteInstitutionDesignationMutation(designationUniqueId: $designationUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`
;
